import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const colors = {
  yellow: '#E2FF2E',
  yellowDim: 'rgba(226, 255, 46, 0.15)',
  black: '#0A0A0A',
  cardBg: '#1A1A1A',
  textPrimary: '#FFFFFF',
  textSecondary: '#A0A0A0',
  textMuted: '#666666',
  red: '#F87171',
  border: '#2A2A2A',
};

const LoginScreen = () => {
  const { signInWithGoogle, error } = useAuth();
  const [loading, setLoading] = useState(false);
  const [localError, setLocalError] = useState(null);

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setLocalError(null);

    try {
      await signInWithGoogle();
    } catch (err) {
      setLocalError(err.message || 'Failed to sign in');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: colors.black }}>
      <div className="w-full max-w-sm">
        {/* Logo / Brand */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold mb-2" style={{ color: colors.yellow }}>
            Trades Beam ⚡
          </h1>
          <p style={{ color: colors.textSecondary }}>
            SNSHN Maintenance Tools
          </p>
        </div>

        {/* Login Card */}
        <div className="rounded-2xl p-6" style={{ background: colors.cardBg }}>
          <h2 className="text-xl font-semibold mb-6 text-center" style={{ color: colors.textPrimary }}>
            Sign in to continue
          </h2>

          {/* Error Display */}
          {(error || localError) && (
            <div className="rounded-xl p-3 mb-4" style={{ background: 'rgba(248, 113, 113, 0.15)' }}>
              <p className="text-sm" style={{ color: colors.red }}>
                {error || localError}
              </p>
            </div>
          )}

          {/* Google Sign In Button */}
          <button
            onClick={handleGoogleSignIn}
            disabled={loading}
            className="w-full py-3 px-4 rounded-xl font-semibold flex items-center justify-center gap-3 transition-all active:scale-98 disabled:opacity-50"
            style={{
              background: colors.textPrimary,
              color: colors.black,
            }}
          >
            {loading ? (
              <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2" style={{ borderColor: colors.black }}></div>
            ) : (
              <>
                {/* Google Icon */}
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                Sign in with Google
              </>
            )}
          </button>

          <p className="text-xs text-center mt-4" style={{ color: colors.textMuted }}>
            Use your SNSHN Google account to sign in
          </p>
        </div>

        {/* Footer */}
        <p className="text-xs text-center mt-6" style={{ color: colors.textMuted }}>
          By signing in, you agree to the SNSHN terms of service
        </p>
      </div>
    </div>
  );
};

export default LoginScreen;
